import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';
class DataTableCommonDataAcademy extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, Masterbase, UserCookie} = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
            if (row.user_rows === 0 && row.status !== '0') { deleteChecked++; }
        });

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
    
                <Row>
                    <Col md={12}>
                        {DataTable?.rows?.length > 0 ? 
                            <Table 
                                responsive 
                                borderless 
                                className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-auto"></th>
                                        <th className="th-width-150p"></th>
                                        <th className="th-width-50p"></th>
                                        <th className="th-td-align-center th-width-50p">
                                            {deleteChecked > 0 && (
                                                <Form.Check 
                                                    type="checkbox"
                                                    checked={Deletes.checkAll}
                                                    onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                />
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DataTable.rows.map((row, index) => {
                                        
                                        Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                        rowId++;

                                        let del = true;
                                        if (row.user_rows > 0 || row.status === '0') { del = false; }

                                        return (
                                            <React.Fragment key={`${rowId}-${row.id}`}>
                                                <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                    <td className="th-td-align-center">
                                                        <CommonRowId rowId={rowId}/>
                                                    </td>
                                                    <td className="text-truncate" title={row.th_name}>
                                                        {row.th_name}                                                 

                                                        <p className="title-xs mt-1 mb-0">
                                                            <i className="fa-classic fa-light fa-location-dot fa-fw me-2"></i>
                                                            {util.formatThaiAddress({
                                                                address: util.combineLocalThaiAddress({
                                                                    no: row.no,
                                                                    village_no: row.village_no,
                                                                    alley: row.alley,
                                                                    road: row.road
                                                                }),
                                                                province_name: row.province_name,
                                                                district_name: row.district_name,
                                                                subdistrict_name: row.subdistrict_name,
                                                                zip_code: row.zip_code
                                                            })}
                                                        </p>

                                                        {(row.coordinator_name || row.phone_number || row.email) && (
                                                            <p className="title-xs mt-1 mb-0">
                                                                {row.coordinator_name && <><i className="fa-classic fa-light fa-user fa-fw me-2"></i>ผู้ประสานงาน {row.coordinator_name}<span className="me-2"></span></>}
                                                                {row.phone_number && <><i className="fa-classic fa-light fa-phone fa-fw me-2"></i>เบอร์ติดต่อ {row.phone_number}<span className="me-2"></span></>}
                                                                {row.email && <><i className="fa-classic fa-light fa-envelope fa-fw me-2"></i>อีเมล {row.email}</>}
                                                            </p>
                                                        )}


                                                        <Badge className="badge-md me-1 mt-2"  bg="dark" pill>{row.academy_code ? `#${row.academy_code}` : ''}</Badge>
                                                        <Badge className="badge-md me-1 mt-2"  bg="success" pill>{row.genAcademyCode ? `#${row.genAcademyCode}` : ''}</Badge>

                                                        <Badge className="badge-md me-1 mt-2"  bg="primary" pill>{row.education_type_name}</Badge>
                                                        <Badge className="badge-md me-1 mt-2"  bg="primary" pill>{row.ministry_name}</Badge>
                                                        <Badge className="badge-md me-1 mt-2"  bg="primary" pill>{row.education_area_name}</Badge>
                                                    </td>
                                                    <td>
                                                        <CommonDropdown
                                                            element="DataTable"
                                                            input={{id: 'status', value: row.status}}
                                                            option={{source: 'options', section: 'status', item: 'default'}}
                                                            callback={(e, element) => onDropDownChange(e, element, {key: 'id', value: row.id} )} 
                                                            disabled={!['0', '1'].includes(UserCookie.types)}
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        <CommonButton 
                                                            task="edit" 
                                                            rounded={false}
                                                            disabled={false}
                                                            callback={(e) => onSetEdit(e, {id: row.id})} 
                                                        />
                                                    </td>
                                                    <td className="th-td-align-center">
                                                        {del && (
                                                            <Form.Check 
                                                                type="checkbox"
                                                                name="deletes"
                                                                value={row.id}
                                                                checked={Deletes.deletes.includes(row.id)}
                                                                onChange={(e) => onCheckDelete(e)} 
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="table-row-gap"><td /></tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        :
                            <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                        }

                        {!Action.Loading.dataTable && (
                            <CommonPagination 
                                Pagination={DataTable.pagination} 

                                handlePagination={(paging) => onPaginationChange(paging)}
                            />
                        )}
                        
                    </Col>
                </Row>

            </Container>
        );
    }
}

export default DataTableCommonDataAcademy;
